// extracted by mini-css-extract-plugin
module.exports =  {"link":"fRbv6hz7AOov9EDm1Mpu","root":"l_HnpYpdiTzKHDr3bYdt"};